/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const WarningCircleFilledIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 24 24"
    onClick={props.onClick}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        id="svg_2"
        d="m11.96729,0.57944c-6.352,0 -11.5,5.148 -11.5,11.5c0,6.352 5.148,11.5 11.5,11.5c6.352,0 11.5,-5.148 11.5,-11.5c0,-6.352 -5.148,-11.5 -11.5,-11.5zm0,18c-0.553,0 -1,-0.447 -1,-1c0,-0.552 0.447,-1 1,-1c0.551,0 1,0.448 1,1c0,0.553 -0.449,1 -1,1zm0.5,-6.035l0,2.535c0,0.276 -0.225,0.5 -0.5,0.5c-0.276,0 -0.5,-0.224 -0.5,-0.5l0,-3c0,-0.276 0.224,-0.5 0.5,-0.5c1.378,0 2.5,-1.121 2.5,-2.5c0,-1.379 -1.122,-2.5 -2.5,-2.5c-1.379,0 -2.5,1.121 -2.5,2.5c0,0.276 -0.225,0.5 -0.5,0.5c-0.276,0 -0.5,-0.224 -0.5,-0.5c0,-1.93 1.569,-3.5 3.5,-3.5c1.93,0 3.5,1.57 3.5,3.5c0,1.76 -1.307,3.221 -3,3.465z"
      />
    </g>
  </svg>
);

export default WarningCircleFilledIcon;
